<template>
    <div class="device-type-add">
        <el-page-header @back="goBack" content="编辑特属专家地址"></el-page-header>
        <el-form label-position="right" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="form"
                 :style="{width: form_width,margin: '20px auto 0 auto'}" autocomplete="off">
            <el-form-item label="特属专家">
<!--                <el-select :disabled="true" v-model="ruleForm.doctor_id" placeholder="请选择特属专家"-->
<!--                           style="width: 100%;">-->
<!--                    <el-option-->
<!--                        v-for="item in allUserDoctor"-->
<!--                        :key="item.user_id"-->
<!--                        :label="item.user_name"-->
<!--                        :value="item.user_id"-->
<!--                    ></el-option>-->
<!--                </el-select>-->
                <el-input type="text" :disabled="true" v-model="doctor_name" placeholder="特属专家姓名"
                          autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="所属单位" prop="hospital">
                <el-input type="text" :disabled="true" v-model="ruleForm.hospital" placeholder="特属专家所属单位"
                          autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="所属科室" prop="department">
                <el-input type="text" :disabled="true" v-model="ruleForm.department" placeholder="特属专家所属科室"
                          autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="所属区域" prop="distinct_id">
                <el-cascader
                    v-model="ruleForm.distinct_id"
                    :options="allRegion" placeholder="请选择所属区域" style="width: 100%;"></el-cascader>
            </el-form-item>
            <el-form-item label="详细地址" prop="address">
                <el-input type="text" v-model="ruleForm.address" placeholder="请输入详细地址" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="默认地址" prop="status">
                <el-radio-group v-model="ruleForm.is_default">
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="2">否</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="状态" prop="status">
                <el-radio-group v-model="ruleForm.status">
                    <el-radio :label="1">启用</el-radio>
                    <el-radio :label="2">停用</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item>
                <el-button @click="goBack">取消</el-button>
                <el-button type="success" @click="submitForm('ruleForm')">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import env from "@/api/env";
import {getUserInfos} from '@/utils/userInfos';
import {check} from "@/utils/checkData";
import {isMobile} from "@/api/order";

export default {
    created() {
        if (isMobile()) {
            this.form_width = "100%"
        }
        localStorage.setItem('prev_page', 'address_edit')
        if (this.$route.query.id) {
            this.ruleForm.id = this.$route.query.id;
        } else {
            this.ruleForm.id = this.$route.params.id;
            this.ruleForm.address = this.$route.params.address;
            this.ruleForm.status = this.$route.params.status;
            this.ruleForm.is_default = this.$route.params.is_default;
            this.ruleForm.distinct_id = this.$route.params.distinct_id;
            this.ruleForm.doctor_id = this.$route.params.doctor_id;
            this.ruleForm.department = this.$route.params.department_name;
            this.ruleForm.hospital = this.$route.params.hosptial_name;
        }
            this.getDetail();

    },
    mounted() {
        this.createParams();
        this.getAllDoctors();
    },
    data() {
        return {
            allRegion: [],
            allUserDoctor: [],
            doctor_name: '',
            ruleForm: {
                id: "",
                doctor_id: "",
                address: "",
                distinct_id: "",
                status: 1,
                is_default: 2,
                department: "",
                hospital: "",
            },
            rules: {
                doctor_id: [
                    {required: true, message: "请选择特属专家", trigger: "blur"},
                ],
                distinct_id: [
                    {required: true, message: "请选择所属区域", trigger: "blur"},
                ],
                address: [
                    {required: true, message: "请输入详细地址", trigger: "blur"},
                ],
                status: [
                    {required: true, message: "请选择状态", trigger: "blur"},
                ],
                is_default: [
                    {required: true, message: "请选择默认地址状态", trigger: "blur"},
                ],
            },
            is_submit: false,
            form_width: "40%",
        };
    },
    methods: {
        getDetail() {
            let params = {
                servername: 'Ruyi_AdminNewOperateServices',
                method: 'getAddressDetail',
                params: {
                    id: this.ruleForm.id
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }

                let data = res.data.data
                this.ruleForm.address = data.address;
                this.ruleForm.status = parseInt(data.status);
                this.ruleForm.is_default = parseInt(data.is_default);
                this.ruleForm.distinct_id = data.distinct_id;
                this.ruleForm.doctor_id = data.doctor_id;
                this.ruleForm.department = data.department_name;
                this.ruleForm.hospital = data.hospital_name;
                this.doctor_name = `${data.hospital_name}/${data.department_name}/${data.user_name}`
            });
        },
        // 所有地区
        createParams() {
            let params = {
                servername: 'Ruyi_AdminOperateServices',
                method: 'allRegion',
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                this.allRegion = res.data.data;
            });
        },
        // 获取所有特属专家
        getAllDoctors() {
            let params = {
                servername: 'Ruyi_AdminNewOperateServices',
                method: 'doctorsListing',
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                this.allUserDoctor = res.data.data;
            });
        },
        // 选择特属专家
        doctorChange() {
            let doctors = this.allUserDoctor;
            let len = doctors.length;

            for (let i = 0; i < len; i++) {
                if (doctors[i].user_id === this.ruleForm.doctor_id) {
                    this.ruleForm.hospital = doctors[i].hospital_name;
                    this.ruleForm.department = doctors[i].department_name;
                }
            }
        },
        // 返回上一页
        goBack() {
            window.history.go(-1);
            return;
        },

        // 提交表单
        submitForm(formName) {
            if (this.is_submit) {
                // 重复提交提醒
                this.$message({
                    type: "warning",
                    message: '正在处理请求，请不要重复提交',
                    duration: 1500,
                });
                return;
            }
            this.is_submit = true;
            let _that = this
            this.$refs[formName].validate(valid => {
                if (valid) {
                    let params = {
                        'servername': 'Ruyi_AdminNewOperateServices',
                        'method': 'editAddress',
                        'params': {
                            id: this.ruleForm.id,
                            doctor_id: this.ruleForm.doctor_id,
                            address: this.ruleForm.address,
                            status: this.ruleForm.status,
                            province_id: this.ruleForm.distinct_id[0],
                            city_id: this.ruleForm.distinct_id[1],
                            distinct_id: this.ruleForm.distinct_id[2],
                            is_default: this.ruleForm.is_default,
                        }
                    };
                    this.$api.service(params).then(res => {
                        if (!check(res)) {
                            this.is_submit = false;
                            return;
                        }
                        this.$message({
                            type: "success",
                            message: '编辑成功',
                            duration: 1500,
                            onClose: function () {
                                _that.is_submit = false;
                                window.history.go(-1);
                                return;
                            }
                        });
                    }).catch(()=>{
                        this.is_submit = false;
                    }).finally(() => {
                        this.is_submit = false;
                    });
                } else {
                    this.$message({
                        type: "error",
                        message: '请输入必填项'
                    });
                    this.is_submit = false;
                    return false;
                }
            });
        },

        changeCompany() {
            this.ruleForm.company_department_id = '';
            this.ruleForm.company_group_id = '';
            this.getAllDeparment();
        },
        changeDeparment() {
            this.ruleForm.company_group_id = '';
            this.getAllCompanyGroup();
        },
        handleUserAvatarImgSuccess(res) {
            if (res.code == 0) {
                this.ruleForm.user_avatar = res.data;
                this.userAvaratImageUrl = this.imgUrl + res.data;
            } else {
                this.$message({
                    type: "error",
                    message: res.msg,
                });
            }
        },

        //上传图片之前，检测文件格式
        beforeAvatarUpload(file) {
            if (file.type === 'image/jpeg' || file.type === 'image/png') {
                var isJPG = true;
            } else {
                var isJPG = false;
            }
            const isLt5M = file.size / 1024 / 1024 < 5;
            if (!isJPG) {
                this.$message.error('图片只能是jpg/png格式!');
            }
            if (!isLt5M) {
                isJPG = false;
                this.$message.error('图片大小不能超过5MB!');

            }
            return isJPG;
        },

    }

};
</script>
<style lang="scss">
@import "@/styles/common.scss";

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 316px;
    height: 200px;
    line-height: 200px;
    text-align: center;
}

.avatar {
    width: 316px;
    height: 200px;
    display: block;
}

.editor {
    line-height: normal !important;
    height: 800px;
}

.ql-snow .ql-tooltip[data-mode=link]::before {
    content: "请输入链接地址:";
}

.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
    border-right: 0px;
    content: '保存';
    padding-right: 0px;
}

.ql-snow .ql-tooltip[data-mode=video]::before {
    content: "请输入视频地址:";
}

.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
    content: '14px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
    content: '10px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
    content: '18px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
    content: '32px';
}

.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
    content: '文本';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
    content: '标题1';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
    content: '标题2';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
    content: '标题3';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
    content: '标题4';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
    content: '标题5';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
    content: '标题6';
}

.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
    content: '标准字体';
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
    content: '衬线字体';
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
    content: '等宽字体';
}
</style>
